/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Monday, May 30th 2022, 2:21:10 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import { GoogleSignInButton } from "./GoogleSignInButton";
import Stack from "@mui/material/Stack";

export const GoogleSignInError = ({ errorMessage = null }) => (
  <div style={{ marginRight: "20px", marginLeft: "20px" }}>
    <Stack spacing={2}>
      <Alert severity="error" variant="filled">
        <AlertTitle>Google Sign In Failed</AlertTitle>
        {errorMessage ? (
          errorMessage
        ) : (
          <>
            We encountered an issue while attempting to sign you in using your Google account. Kindly click on the
            Google sign in button below to attempt again.
          </>
        )}
      </Alert>
      <GoogleSignInButton />
    </Stack>
  </div>
);
